import { GameConfig } from '../types.ts';

/** Shared simulation parameters for both game modes — not user-configurable */
export const FIXED_GAME_CONFIG: GameConfig = {
  gridSize: 10,
  startingFires: 5,
  spreadChance: 0.4,
  teleportChance: 0.2,
  fireInterval: 800,
  isTurnBased: true,
};
